import * as React from 'react';
import { useContext, useState, useEffect } from 'react';
import { Button as MUIButton, Stack, CircularProgress } from '@mui/material';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import { useForm } from 'react-hook-form';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import BreadcrumbsWrapper from '../../../components/breadcrumbs' 

export default function EditPartner() {
  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [username, setUsername] = useState('');
  const { id } = useParams(); // partner id from route
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
  } = useForm();

  const foreName = watch('forename');
  const surname = watch('surname');

  useEffect(() => {
    if (foreName && surname) {
      const uname = (foreName[0] || '').toLowerCase() + (surname.replace(/\s/g, '').toLowerCase() || '');
      setUsername(uname);
      setValue('username', uname, { shouldValidate: true, shouldDirty: true });
    }
  }, [foreName, surname, setValue]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await postRequest('private/GetProducts', {}, authCtx.token);
        console.log(res , 'RESKDFDS')
        if (res?.status === 200 && Array.isArray(res.data)) {
          setProductList(res.data);
        }
      } catch (err) {
        toast.error('Failed to fetch products');
      }
    };

    const fetchPartnerDetails = async () => {
      try {
        const res = await postRequest(`private/IndividualPartner/${id}`, {}, authCtx.token);
        if (res?.status === 200) {
          const data = res.data;
          setValue('name', data.name);
          setValue('uses_mlm_branches', data.uses_mlm_branches);
          setValue('uses_mlm_automation', data.uses_mlm_automation);
          setSelectedProducts(data.product_id || []);
        }
      } catch (err) {
        toast.error('Failed to fetch partner details');
      }
    };

    fetchProducts();
    fetchPartnerDetails();
  }, [id, authCtx.token, setValue]);

  const toggleProduct = (productId) => {
    setSelectedProducts((prev) =>
      prev.includes(productId) ? prev.filter((id) => id !== productId) : [...prev, productId]
    );
  };

  const onSubmit = async (data) => {
    console.log(data , 'DATA@123')
    setLoading(true);
    try {
      const payload = {
        name:data.name,
        uses_mlm_automation:data.uses_mlm_automation,
       uses_mlm_branches:data.uses_mlm_branches,
        product_id: selectedProducts,
        id,
      };
      const res = await postRequest(`private/EditPartner/${id}`, payload, authCtx.token);
      console.log(res , 'res@123')
      if (res?.status === 200) {
        toast.success('Partner updated successfully');
        navigate('/partners');
      } else {
        toast.error(res?.message || 'Update failed');
      }
    } catch (err) {
      toast.error(err?.message || 'Update failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BreadcrumbsWrapper
                                    items={[
                                      { label: 'Dashboard', path: '/dashboard' },
                                      { label: 'Partners', path: '/partners' },
                                      { label: 'Edit Partner', path: '' },
                                    ]}
                                  />
                            <br></br>
      <div className='page-header'>
        <h1 className='mt-0'>Edit Partner</h1>
      </div>

      <div className='page-top-formview mb-3'>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="partnerName">
              <Form.Label>Partner Name</Form.Label>
              <Form.Control
                type="text"
                {...register('name', { required: 'Partner name is required' })}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">{errors.name?.message}</Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="mlmBranches">
              <Form.Check type="checkbox" label="Uses MLM Branches / Pricing" {...register('uses_mlm_branches')} />
            </Form.Group>
            <Form.Group as={Col} controlId="mlmAutomation">
              <Form.Check
                type="checkbox"
                label="Uses MLM Automation and Email Templates"
                {...register('uses_mlm_automation')}
              />
            </Form.Group>
          </Row>

      <Row className="mb-4">
  <Form.Group as={Col}>
    <Form.Label className="fw-bold mb-2" style={{ fontSize: '1.1rem' }}>Select Products</Form.Label>
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        padding: '10px',
        background: '#f9f9f9',
        borderRadius: '8px',
        border: '1px solid #ddd',
        minHeight: '60px',
      }}
    >
      {productList.length === 0 && (
        <div style={{ color: '#999' }}>No products found</div>
      )}

      {productList.map((product) => {
        const isSelected = selectedProducts.includes(product._id);
        return (
          <MUIButton
            key={product._id}
            variant={isSelected ? 'contained' : 'outlined'}
            color={isSelected ? 'primary' : 'inherit'}
            size="small"
            onClick={() => toggleProduct(product._id)}
            style={{
              borderRadius: '20px',
              textTransform: 'none',
              padding: '6px 14px',
              fontWeight: 500,
              fontSize: '0.9rem',
              backgroundColor: isSelected ? '#1976d2' : '',
              color: isSelected ? '#fff' : '#333',
              borderColor: isSelected ? '#1976d2' : '#ccc',
            }}
          >
            {product.title}
          </MUIButton>
        );
      })}
    </div>
  </Form.Group>
</Row>


          <Stack direction="row" spacing={2}>
            <MUIButton variant="outlined" onClick={() => navigate('/partners')} color="inherit" type="button">
              Cancel
            </MUIButton>
            <MUIButton variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Update'}
            </MUIButton>
          </Stack>
        </Form>
      </div>
    </>
  );
}
